import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 border border-white/10 hover:border-yamai-cyan-400/50 group"
      aria-label="Switch language"
    >
      <Globe 
        size={18} 
        className="text-yamai-cyan-400 group-hover:text-yamai-cyan-300 transition-colors" 
      />
      <span className="text-sm font-semibold text-white uppercase">
        {language}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
